import React, { Fragment } from "react"
import { activeAdminLink } from "../../../helpers/navigationHelpers"
import { navigationPaths } from "../../../constants/paths"
import { Grid, Menu, Header, Item, Label } from "semantic-ui-react"

export default class ShopOrderTooltipHeaderNav extends React.Component {
  render() {
    const { activeTab, switchTab, tabData, order } = this.props
    const { id, updated_at, status, is_fixed_price } = order

    return (
      <Fragment>
        <Grid stretched>
          <Grid.Column width="8">
            <Header size="medium" style={{ marginBottom: 0 }}>
              Shop Order
              <a
                href={activeAdminLink(`shop_orders/${id}`)}
                rel="noopener noreferrer"
                target="_blank"
              >
                <small style={{ paddingLeft: "5px" }}>(view)</small>
              </a>
            </Header>
            <a
              href={`${navigationPaths.shopOrderHistory(id)}`}
              rel="noopener noreferrer"
              target="_blank"
            >
              <small>updated_at {updated_at}</small>
            </a>
          </Grid.Column>
          <Grid.Column
            width="8"
            textAlign="right"
            style={{ paddingRight: "30px" }}
          >
            <Item>{status}</Item>
            {is_fixed_price && (
              <Item>
                <Label tag color="green" style={{ marginTop: "5px" }}>
                  FIXED PRICE
                </Label>
              </Item>
            )}
          </Grid.Column>
        </Grid>
        <Menu secondary={true} pointing color="blue">
          {tabData.map((data, i) => {
            return (
              <Menu.Item
                key={`tab-${i}`}
                active={activeTab === data.tab}
                onClick={() => switchTab(data.tab)}
              >
                {data.label}
              </Menu.Item>
            )
          })}
        </Menu>
      </Fragment>
    )
  }
}
